import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { Formik } from "formik";
import * as yup from "yup";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Form, Modal, Button } from "react-bootstrap";
import { Stack, Tooltip } from "@mui/material";
import moment from "moment";
import { nanoid } from "nanoid";
import DeleteIcon from "@mui/icons-material/Delete";
import { ModalAllder } from "layouts/ModalAllder";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { myCart } from "../redux/handlers/catalog/myCart.handler";
import { updateCart } from "../redux/handlers/catalog/updateCart.handler";
import { submitCart, clearsubmitCart } from "../redux/handlers/catalog/submitCart.handler";
import { deleteCart, cleardeleteCart } from "../redux/handlers/catalog/deleteCart.handler";
import "styles/catalog.css";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import sarabun from "fonts/SarabunRegular.ttf";
import sarabunBold from "fonts/SarabunSemiBold.ttf";
import NotoSansLao from "fonts/NotoSansLaoSemiCondensedRegular.ttf";
import NotoSansLaoBold from "fonts/NotoSansLaoSemiCondensedBold.ttf";
import phetsarath from "../fonts/PhetsarathRegular.ttf";
import phetsarathBold from "../fonts/PhetsarathBold.ttf";
var getCartProductDisplayName = function(item, language) {
    if (language === "la") {
        return (item === null || item === void 0 ? void 0 : item.tmprs_catalog_namela) || (item === null || item === void 0 ? void 0 : item.tmprs_catalog_nameen) || "-";
    }
    return (item === null || item === void 0 ? void 0 : item.tmprs_catalog_name) || (item === null || item === void 0 ? void 0 : item.tmprs_catalog_nameen) || "-";
};
var getCartProductSecondaryName = function(item) {
    return (item === null || item === void 0 ? void 0 : item.tmprs_catalog_nameen) || "";
};
var isCartProductNew = function(item) {
    return Number(item === null || item === void 0 ? void 0 : item.tmprs_catalog_new) === 1;
};
var isComplimentaryCartProduct = function(item) {
    return Number(item === null || item === void 0 ? void 0 : item.tmprs_catalog_free) === 2 || Number(item === null || item === void 0 ? void 0 : item.tmprs_catalog_tester) === 2;
};
var normalizeQuantityInput = function(rawValue) {
    if (rawValue === "") return "";
    var digitsOnly = String(rawValue).replace(/\D/g, "");
    return digitsOnly.replace(/^0+(?=\d)/, "");
};
var normalizeDecimalInput = function(rawValue) {
    if (rawValue === "") return "";
    var sanitizedValue = String(rawValue).replace(/[^\d.]/g, "");
    var _sanitizedValue_split = _to_array(sanitizedValue.split(".")), tmp = _sanitizedValue_split[0], rawInteger = tmp === void 0 ? "" : tmp, decimalParts = _sanitizedValue_split.slice(1);
    var integerPart = rawInteger.replace(/^0+(?=\d)/, "") || "0";
    return decimalParts.length > 0 ? "".concat(integerPart, ".").concat(decimalParts.join("")) : integerPart;
};
var calculateDetailPricingFromExVat = function(detail, promotion, rawExVat) {
    var wholesale = rawExVat === "" || rawExVat === null || rawExVat === undefined ? 0 : Number(rawExVat) || 0;
    var pricing = {
        tmprs_detail_discount: 0,
        tmprs_detail_wholesale: rawExVat,
        tmprs_detail_wholesalevat: rawExVat === "" ? "" : +(wholesale * 1.1).toFixed(2),
        tmprs_detail_wholesaledis: 0,
        tmprs_detail_wholesalevatdis: 0,
        tmprs_detail_wholesaleavg: 0
    };
    if (!promotion || !wholesale) {
        return pricing;
    }
    var promotionUnitId = Number(promotion.set_promotion_unitid);
    var detailUnitId = Number(detail.tmprs_detail_unitid);
    var promotionDiscount = Number(promotion.set_promotion_discount) || 0;
    var isPromotionUnitMatched = promotionUnitId === 6 && detailUnitId === 6 || promotionUnitId === 7 && detailUnitId === 7 || promotionUnitId === 4 && (detailUnitId === 4 || detailUnitId === 7);
    if ((promotion.set_promotion_type === 1 || promotion.set_promotion_type === 2) && isPromotionUnitMatched) {
        pricing.tmprs_detail_discount = promotionDiscount;
        pricing.tmprs_detail_wholesaledis = promotion.set_promotion_type === 1 ? Math.max(0, wholesale - promotionDiscount) : Math.max(0, wholesale - wholesale * promotionDiscount / 100);
        pricing.tmprs_detail_wholesalevatdis = +(pricing.tmprs_detail_wholesaledis * 1.1).toFixed(2);
    } else if (promotion.set_promotion_type === 3 && detailUnitId === 4) {
        var promotionBuy = Number(promotion.set_promotion_buy) || 0;
        var promotionFree = Number(promotion.set_promotion_free) || 0;
        var totalFree = promotionBuy + promotionFree;
        if (totalFree > 0) {
            pricing.tmprs_detail_wholesaleavg = +(wholesale * promotionBuy / totalFree).toFixed(2);
        }
    }
    return pricing;
};
var getDetailUnitPrice = function(detail, vatCal) {
    if (detail.tmprs_detail_wholesaleavg && detail.tmprs_detail_wholesaleavg > 0) {
        return Number((detail.tmprs_detail_wholesaleavg * (Number(vatCal || 1) === 1 ? 1 : 1.1)).toFixed(2));
    }
    if (Number(vatCal || 1) === 1) {
        return detail.tmprs_detail_wholesaledis && detail.tmprs_detail_wholesaledis > 0 ? detail.tmprs_detail_wholesaledis : detail.tmprs_detail_wholesale || 0;
    }
    return detail.tmprs_detail_wholesalevatdis && detail.tmprs_detail_wholesalevatdis > 0 ? detail.tmprs_detail_wholesalevatdis : detail.tmprs_detail_wholesalevat || 0;
};
export function Cart() {
    var param = useParams();
    var location = useLocation();
    var guestId = useMemo(function() {
        return param.guestId ? param.guestId : null;
    }, [
        param.guestId
    ]);
    var cartParams = useMemo(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
    var queryShopId = cartParams.get("shopid");
    var queryBranchId = cartParams.get("branchid");
    var queryTypeShop = cartParams.get("typeShop");
    var queryVatCal = cartParams.get("vatcal");
    // ตั้งค่า 2 ภาษา
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var _useState = _sliced_to_array(useState(!localStorage.getItem("lang") ? "th" : localStorage.getItem("lang")), 2), language = _useState[0], setLanguage = _useState[1];
    var onClickLanguage = function() {
        if (language == "th") {
            setLanguage("la");
        } else {
            setLanguage("th");
        }
    };
    useEffect(function() {
        i18n.changeLanguage(language);
        localStorage.setItem("lang", language);
    }, [
        language
    ]);
    useEffect(function() {
        var savedLang = localStorage.getItem("lang");
        if (savedLang) i18n.changeLanguage(savedLang);
    }, [
        i18n
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState1 = _sliced_to_array(useState(""), 2), shopBranch = _useState1[0], setShopBranch = _useState1[1];
    var shopType = shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.shShop;
    var typeIdShop = queryTypeShop || (shopType === null || shopType === void 0 ? void 0 : shopType.sh_shop_typeshop) == 1 && "RT" || (shopType === null || shopType === void 0 ? void 0 : shopType.sh_shop_typeshop) == 2 && "WT" || (shopType === null || shopType === void 0 ? void 0 : shopType.sh_shop_typeshop) == 3 && "MT" || "";
    var cartPayload = useMemo(function() {
        var shopid = parseInt(queryShopId || (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid));
        var shbranchid = parseInt(queryBranchId || (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id));
        if (!guestId || !shopid || !shbranchid) return null;
        return {
            guestid: parseInt(guestId),
            shopid: shopid,
            shbranchid: shbranchid
        };
    }, [
        guestId,
        queryBranchId,
        queryShopId,
        shopBranch
    ]);
    var _useState2 = _sliced_to_array(useState({
        branchid: null,
        branch_shid: null,
        rs_reserve_shipping_paytype: 2,
        catalog_credate: moment().format("DD/MM/YYYY")
    }), 2), formData = _useState2[0], setFormData = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), modelText = _useState6[0], setmodelText = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), dataPrint = _useState7[0], setDataPrint = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 350,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 350,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), submitDialog = _useState9[0], setSubmitDialog = _useState9[1];
    var schema = yup.object().shape({
        branchid: yup.string().required(""),
        rs_reserve_shipping_paytype: yup.number().oneOf([
            1,
            2
        ]).required("")
    });
    var canSelectOriginShipping = Number(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shipping_paytype) === 1;
    var myCartReducer = useAppSelector(function(state) {
        return state.myCartReducer;
    });
    var updateCartReducer = useAppSelector(function(state) {
        return state.updateCartReducer;
    });
    var submitCartReducer = useAppSelector(function(state) {
        return state.submitCartReducer;
    });
    useEffect(function() {
        if (cartPayload) {
            dispatch(myCart(cartPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        cartPayload
    ]);
    useEffect(function() {
        setIsLoading(myCartReducer.isFetching);
        if (guestId) {
            if (myCartReducer.data) {
                var newData = myCartReducer.data.data.map(function(catalog) {
                    return _object_spread_props(_object_spread({}, catalog), {
                        TmprsDetail: catalog.TmprsDetail.map(function(detail) {
                            return _object_spread_props(_object_spread({}, detail), {
                                idDetail: nanoid()
                            });
                        })
                    });
                });
                setRowData(newData);
                var firstCatalog = myCartReducer.data.data[0];
                if ((firstCatalog === null || firstCatalog === void 0 ? void 0 : firstCatalog.shBranch) && (firstCatalog === null || firstCatalog === void 0 ? void 0 : firstCatalog.shShop) && (!shopBranch || Number(shopBranch.sh_branch_id) !== Number(firstCatalog.shBranch.sh_branch_id) || !shopBranch.shShop || Number(shopBranch.sh_branch_shipping_paytype) !== Number(firstCatalog.shBranch.sh_branch_shipping_paytype))) {
                    setShopBranch(_object_spread_props(_object_spread({}, firstCatalog.shBranch), {
                        sh_branch_shid: firstCatalog.tmprs_catalog_shid,
                        shShop: firstCatalog.shShop
                    }));
                }
            }
        }
    }, [
        myCartReducer,
        guestId,
        shopBranch
    ]);
    useEffect(function() {
        setIsLoading(updateCartReducer.isFetching);
        if (cartPayload) {
            if (updateCartReducer.data && !updateCartReducer.isError) {
                dispatch(myCart(cartPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            // dispatch(myCart(parseInt(guestId), { modalObj, setModalObj }));
            }
        }
    }, [
        updateCartReducer,
        cartPayload
    ]);
    var buildUpdatedDetail = function(detail, patch, promotion) {
        var nextDetail = _object_spread({}, detail, patch);
        var hasExVatPatch = Object.prototype.hasOwnProperty.call(patch, "tmprs_detail_wholesale");
        var pricing = hasExVatPatch ? calculateDetailPricingFromExVat(detail, promotion, patch.tmprs_detail_wholesale) : {
            tmprs_detail_discount: detail.tmprs_detail_discount,
            tmprs_detail_wholesale: detail.tmprs_detail_wholesale,
            tmprs_detail_wholesalevat: detail.tmprs_detail_wholesalevat,
            tmprs_detail_wholesaledis: detail.tmprs_detail_wholesaledis,
            tmprs_detail_wholesalevatdis: detail.tmprs_detail_wholesalevatdis,
            tmprs_detail_wholesaleavg: detail.tmprs_detail_wholesaleavg
        };
        var detailWithPricing = _object_spread({}, nextDetail, pricing);
        var amount = Number(detailWithPricing.tmprs_detail_amount) || 0;
        var amountItem = amount * (Number(detailWithPricing.tmprs_detail_ratio) || 0);
        var unitPrice = getDetailUnitPrice(detailWithPricing, Number((shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_vatcal) || queryVatCal || 1));
        return _object_spread_props(_object_spread({}, detailWithPricing), {
            tmprs_detail_amountitem: amountItem,
            tmprs_detail_net: amount > 0 ? unitPrice * amount : 0
        });
    };
    var updateDetailLocal = function(detailId, patch) {
        setRowData(function(prev) {
            return prev.map(function(catalog) {
                return _object_spread_props(_object_spread({}, catalog), {
                    TmprsDetail: catalog.TmprsDetail.map(function(detail) {
                        return detail.idDetail === detailId ? buildUpdatedDetail(detail, patch, catalog.setPromotion) : detail;
                    })
                });
            });
        });
    };
    var updateCatalogLocal = function(catalogId, patch) {
        setRowData(function(prev) {
            return prev.map(function(catalog) {
                return catalog.tmprs_catalog_id === catalogId ? _object_spread({}, catalog, patch) : catalog;
            });
        });
    };
    var onChangeUpdateCart = function(event, newValue, wholesaleValue) {
        var catalogPatch = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var data = _object_spread({
            guestid: parseInt(guestId),
            detailid: parseInt(event.tmprs_detail_id),
            amount: parseInt(newValue),
            wholesale: wholesaleValue !== undefined ? Number(wholesaleValue) || 0 : Number(event.tmprs_detail_wholesale) || 0
        }, catalogPatch);
        dispatch(updateCart(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        var shopReserve = localStorage.getItem("shop_reserve");
        if (shopReserve) {
            try {
                setShopBranch(JSON.parse(shopReserve));
            } catch (err) {
                setShopBranch(null);
            }
        } else {
            setShopBranch(null);
        }
    }, []);
    useEffect(function() {
        if (queryShopId && queryBranchId || shopBranch) {
            setFormData(function(prev) {
                var _shopBranch_shShop, _shopBranch_sysUser;
                return _object_spread_props(_object_spread({}, prev), {
                    branchid: queryBranchId || (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id),
                    branch_name: (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_name) || "",
                    branch_shid: queryShopId || (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
                    shop_name: (shopBranch === null || shopBranch === void 0 ? void 0 : (_shopBranch_shShop = shopBranch.shShop) === null || _shopBranch_shShop === void 0 ? void 0 : _shopBranch_shShop.sh_shop_name) || "",
                    sale: (shopBranch === null || shopBranch === void 0 ? void 0 : (_shopBranch_sysUser = shopBranch.sysUser) === null || _shopBranch_sysUser === void 0 ? void 0 : _shopBranch_sysUser.sys_user_fullname) || "",
                    sh_branch_contactname: (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_contactname) || "",
                    sh_branch_contactphone: (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_contactphone) || "",
                    sh_branch_suptactname: (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_suptactname) || "",
                    sh_branch_suptactphone: (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_suptactphone) || "",
                    rs_reserve_shipping_paytype: Number(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shipping_paytype) === 1 ? 1 : 2
                });
            });
        }
    }, [
        queryBranchId,
        queryShopId,
        shopBranch
    ]);
    useEffect(function() {
        setIsLoading(submitCartReducer.isFetching);
        if (submitCartReducer.data && guestId && rowData.length > 0) {
            var _submitCartReducer_data_lineNotification;
            var newData = {
                cartDetail: rowData,
                form: submitCartReducer.data.data,
                lineWarning: ((_submitCartReducer_data_lineNotification = submitCartReducer.data.lineNotification) === null || _submitCartReducer_data_lineNotification === void 0 ? void 0 : _submitCartReducer_data_lineNotification.success) === false ? submitCartReducer.data.message : null
            };
            setDataPrint(newData);
            setSubmitDialog(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setmodelText(t("save_1"));
            setRowData([]);
            dispatch(clearsubmitCart());
            if (cartPayload) {
                dispatch(myCart(cartPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj,
                    silentError: true
                }));
            }
        }
    }, [
        submitCartReducer
    ]);
    var componentRef = useRef();
    var handleOpenPrint = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, newWindow, fileName;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                dataFrom: dataPrint === null || dataPrint === void 0 ? void 0 : dataPrint.form,
                                dataItem: dataPrint === null || dataPrint === void 0 ? void 0 : dataPrint.cartDetail,
                                typeIdShop: typeIdShop,
                                language: language
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        console.log("\uD83D\uDE80 -------------------------------------------\uD83D\uDE80");
                        console.log("\uD83D\uDE80 ~ handleOpenPrint ~ language:\n", language);
                        console.log("\uD83D\uDE80 -------------------------------------------\uD83D\uDE80");
                        // เปิด PDF ในหน้าต่างใหม่
                        newWindow = window.open(url, "_blank");
                        // เตรียมปุ่มดาวน์โหลด
                        if (newWindow) {
                            fileName = language == "th" ? "ใบจองสินค้า".concat(moment().format("YYYYMMDDHHmmss"), ".pdf") : "ໃບຈອງສິນຄ້າ".concat(moment().format("YYYYMMDDHHmmss"), ".pdf");
                            // Inject ปุ่มดาวน์โหลดลงในแท็บใหม่
                            newWindow.document.write("\n      <html>\n        <head>\n          <title>".concat(fileName, '</title>\n        </head>\n        <body style="margin:0;">\n          <iframe src="').concat(url, '" width="100%" height="100%" style="border:none;"></iframe>\n        </body>\n      </html>\n      '));
                        } else {
                            alert("ไม่สามารถเปิดหน้าต่างใหม่ได้ กรุณาอนุญาต pop-up");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOpenPrint() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, link;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                dataFrom: dataPrint === null || dataPrint === void 0 ? void 0 : dataPrint.form,
                                dataItem: dataPrint === null || dataPrint === void 0 ? void 0 : dataPrint.cartDetail,
                                typeIdShop: typeIdShop,
                                language: language
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        link.download = language == "th" ? "ใบจองสินค้า".concat(moment().format("YYYYMMDDHHmmss"), ".pdf") : "ໃບຈອງສິນຄ້າ".concat(moment().format("YYYYMMDDHHmmss"), ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var totalNet = rowData.reduce(function(sum, item) {
        return sum + item.tmprs_catalog_net;
    }, 0);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "p-2" : "p-1",
                children: [
                    !isMobile ? /*#__PURE__*/ _jsxs("div", {
                        className: "pagezoom",
                        children: [
                            /*#__PURE__*/ _jsxs(Stack, {
                                direction: "row",
                                justifyContent: "space-between",
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-24",
                                        children: t("shopping cart")
                                    }),
                                    /*#__PURE__*/ _jsxs(Tooltip, {
                                        title: t("change language"),
                                        onClick: function(e) {
                                            return onClickLanguage();
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(LanguageIcon, {
                                                style: {
                                                    fontSize: 30,
                                                    cursor: "pointer"
                                                },
                                                className: "me-2"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: language == "th" ? "ภาษาไทย" : "ພາສາລາວ"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Stack, {
                                direction: "row",
                                justifyContent: "flex-end",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    className: "btn btn-dg w-[150px]",
                                    to: "/catalog/".concat(typeIdShop, "?openExternalBrowser=1"),
                                    children: t("add products")
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    height: "auto",
                                    overflowX: "auto",
                                    overflowY: "scroll"
                                },
                                className: "table-scroll-x",
                                children: /*#__PURE__*/ _jsxs("table", {
                                    className: "product-table mt-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("thead", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: "2",
                                                            colSpan: "3",
                                                            children: t("product lists")
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            colSpan: "2",
                                                            style: {
                                                                width: "80px"
                                                            },
                                                            children: t("wholesale price")
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: "2",
                                                            style: {
                                                                width: "150px"
                                                            },
                                                            children: t("number of products")
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: "2",
                                                            style: {
                                                                width: "150px"
                                                            },
                                                            children: t("total")
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            rowSpan: "2",
                                                            style: {
                                                                width: "120px"
                                                            },
                                                            children: t("delete product")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: t("ex vat")
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: t("in vat")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: rowData.map(function(row, i) {
                                                return /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                width: 560,
                                                                minWidth: 560,
                                                                maxWidth: 560
                                                            },
                                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                                direction: "row",
                                                                justifyContent: "flex-start",
                                                                children: [
                                                                    row.tmprs_catalog_image ? /*#__PURE__*/ _jsx("img", {
                                                                        src: row.tmprs_catalog_image,
                                                                        alt: "สินค้า",
                                                                        style: {
                                                                            width: 100,
                                                                            height: 100
                                                                        }
                                                                    }) : "",
                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                        className: "ml-3 d-block",
                                                                        style: {
                                                                            width: 400,
                                                                            minWidth: 400,
                                                                            maxWidth: 400
                                                                        },
                                                                        children: [
                                                                            isCartProductNew(row) && /*#__PURE__*/ _jsx("div", {
                                                                                className: "mb-[5px] text-danger text-left fs-20",
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: "NEW"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "mb-[12px] text-left",
                                                                                children: getCartProductDisplayName(row, language)
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "mb-[12px] tc-7 fs-12 text-left",
                                                                                children: getCartProductSecondaryName(row)
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "d-flex align-items-center gap-2 mb-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        type: "checkbox",
                                                                                        label: "ของแถม",
                                                                                        checked: Number(row.tmprs_catalog_free) === 2,
                                                                                        onChange: function(e) {
                                                                                            var _row_TmprsDetail;
                                                                                            var isFree = e.target.checked;
                                                                                            var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                                            if (!firstDetail) return;
                                                                                            updateCatalogLocal(row.tmprs_catalog_id, _object_spread({
                                                                                                tmprs_catalog_free: isFree ? 2 : 1
                                                                                            }, isFree && {
                                                                                                tmprs_catalog_tester: 1
                                                                                            }));
                                                                                            var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                                            onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                                                free: isFree ? 2 : 1,
                                                                                                tester: isFree ? 1 : Number(row.tmprs_catalog_tester) === 2 ? 2 : 1
                                                                                            });
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        type: "checkbox",
                                                                                        label: "สินค้าทดลอง",
                                                                                        checked: Number(row.tmprs_catalog_tester) === 2,
                                                                                        onChange: function(e) {
                                                                                            var _row_TmprsDetail;
                                                                                            var isTester = e.target.checked;
                                                                                            var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                                            if (!firstDetail) return;
                                                                                            updateCatalogLocal(row.tmprs_catalog_id, _object_spread({
                                                                                                tmprs_catalog_tester: isTester ? 2 : 1
                                                                                            }, isTester && {
                                                                                                tmprs_catalog_free: 1
                                                                                            }));
                                                                                            var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                                            onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                                                free: isTester ? 1 : Number(row.tmprs_catalog_free) === 2 ? 2 : 1,
                                                                                                tester: isTester ? 2 : 1
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                as: "textarea",
                                                                                rows: 2,
                                                                                size: "sm",
                                                                                placeholder: "หมายเหตุ",
                                                                                style: {
                                                                                    width: "100%"
                                                                                },
                                                                                value: row.tmprs_catalog_remark || "",
                                                                                onChange: function(e) {
                                                                                    return updateCatalogLocal(row.tmprs_catalog_id, {
                                                                                        tmprs_catalog_remark: e.target.value
                                                                                    });
                                                                                },
                                                                                onBlur: function(e) {
                                                                                    var _row_TmprsDetail;
                                                                                    var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                                    if (!firstDetail) return;
                                                                                    var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                                    onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                                        remark: e.target.value
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) {
                                                                var _ele_clDetail;
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-center mb-[22px]",
                                                                    children: (ele === null || ele === void 0 ? void 0 : (_ele_clDetail = ele.clDetail) === null || _ele_clDetail === void 0 ? void 0 : _ele_clDetail.cl_detail_showbarcode) == 1 ? ele.tmprs_detail_barcode : ""
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "text-left mb-[22px]",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                float: "left",
                                                                                width: "40px"
                                                                            },
                                                                            children: language == "th" ? " ".concat(ele.setUnit.set_unit_name) : " ".concat(ele.setUnit.set_unit_namela)
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: "="
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                            style: {
                                                                                borderRadius: 5
                                                                            },
                                                                            children: ele.tmprs_detail_ratio ? " ".concat(ele.tmprs_detail_ratio) : ""
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: ele.tmprs_detail_ratio ? " ".concat(t("item")) : ""
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: ele.tmprs_detail_ratiooption ? " / ".concat(ele.tmprs_detail_ratiooption, " ").concat(t("pack")) : ""
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) /*#__PURE__*/ {
                                                                var _ele_tmprs_detail_wholesale;
                                                                return _jsx("div", {
                                                                    className: "".concat(ele.tmprs_detail_wholesaledis ? "mb-[0px]" : "mb-[15px]"),
                                                                    children: /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        // justifyContent="space-between"
                                                                        justifyContent: "flex-end",
                                                                        alignContent: "flex-end",
                                                                        alignItems: "flex-end",
                                                                        children: /*#__PURE__*/ _jsx(Stack, {
                                                                            direction: "column",
                                                                            justifyContent: "flex-end",
                                                                            alignContent: "flex-end",
                                                                            alignItems: "flex-end",
                                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                inputMode: "decimal",
                                                                                pattern: "[0-9]*[.]?[0-9]*",
                                                                                className: "text-end",
                                                                                style: {
                                                                                    width: 120
                                                                                },
                                                                                value: isComplimentaryCartProduct(row) ? 0 : (_ele_tmprs_detail_wholesale = ele.tmprs_detail_wholesale) !== null && _ele_tmprs_detail_wholesale !== void 0 ? _ele_tmprs_detail_wholesale : "",
                                                                                disabled: isComplimentaryCartProduct(row),
                                                                                onChange: function(e) {
                                                                                    var newValue = normalizeDecimalInput(e.target.value);
                                                                                    updateDetailLocal(ele.idDetail, {
                                                                                        tmprs_detail_wholesale: newValue
                                                                                    });
                                                                                },
                                                                                onBlur: function(e) {
                                                                                    var newValue = normalizeDecimalInput(e.target.value);
                                                                                    var _ele_tmprs_detail_amount;
                                                                                    onChangeUpdateCart(ele, (_ele_tmprs_detail_amount = ele.tmprs_detail_amount) !== null && _ele_tmprs_detail_amount !== void 0 ? _ele_tmprs_detail_amount : 0, newValue);
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "".concat(ele.tmprs_detail_wholesalevatdis ? "mb-[0px]" : "mb-[22px]"),
                                                                    children: /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        // justifyContent="space-between"
                                                                        justifyContent: "flex-end",
                                                                        alignContent: "flex-end",
                                                                        alignItems: "flex-end",
                                                                        children: /*#__PURE__*/ _jsx(Stack, {
                                                                            direction: "column",
                                                                            justifyContent: "flex-end",
                                                                            alignContent: "flex-end",
                                                                            alignItems: "flex-end",
                                                                            children: isComplimentaryCartProduct(row) ? /*#__PURE__*/ _jsx("span", {
                                                                                style: {
                                                                                    color: "#212529"
                                                                                },
                                                                                children: NumberFormat(0, 2)
                                                                            }) : ele.tmprs_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        style: {
                                                                                            color: "#b00312"
                                                                                        },
                                                                                        children: NumberFormat(ele.tmprs_detail_wholesalevatdis ? ele.tmprs_detail_wholesalevatdis : 0, 2)
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        class: "old-price",
                                                                                        children: NumberFormat(ele.tmprs_detail_wholesalevat ? ele.tmprs_detail_wholesalevat : 0, 2)
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ _jsx("span", {
                                                                                style: {
                                                                                    color: "#212529"
                                                                                },
                                                                                children: NumberFormat(ele.tmprs_detail_wholesalevat ? ele.tmprs_detail_wholesalevat : 0, 2)
                                                                            })
                                                                        })
                                                                    })
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) /*#__PURE__*/ {
                                                                var _ele_tmprs_detail_amount;
                                                                return _jsx("center", {
                                                                    children: ele.cl_detail_unitid == 6 ? /*#__PURE__*/ _jsx("div", {
                                                                        className: "mb-[30px]"
                                                                    }) : /*#__PURE__*/ _jsx("input", {
                                                                        type: "text",
                                                                        inputMode: "numeric",
                                                                        pattern: "[0-9]*",
                                                                        className: "form-control mb-[15px] w-[50px]",
                                                                        value: (_ele_tmprs_detail_amount = ele.tmprs_detail_amount) !== null && _ele_tmprs_detail_amount !== void 0 ? _ele_tmprs_detail_amount : 0,
                                                                        onChange: function(e) {
                                                                            var newValue = normalizeQuantityInput(e.target.value);
                                                                            onChangeUpdateCart(ele, newValue === "" ? 0 : newValue);
                                                                            updateDetailLocal(ele.idDetail, {
                                                                                tmprs_detail_amount: newValue
                                                                            });
                                                                        }
                                                                    })
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            style: {
                                                                padding: "8px"
                                                            },
                                                            children: row.TmprsDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-right mb-[22px]",
                                                                    children: NumberFormat(isComplimentaryCartProduct(row) ? 0 : ele.tmprs_detail_net, 2)
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx("center", {
                                                                children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                                    className: "mb-[22px]",
                                                                    style: {
                                                                        color: "#FFFFFF",
                                                                        fontSize: 30,
                                                                        borderRadius: 40,
                                                                        background: "#F95057",
                                                                        padding: 5,
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: function() {
                                                                        setModalDel(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                open: true,
                                                                                data: {
                                                                                    id: row.tmprs_catalog_id,
                                                                                    name: row.tmprs_catalog_name
                                                                                }
                                                                            });
                                                                        });
                                                                        setmodelText(t("confirm product deletion"));
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }),
                                        rowData.length > 0 && /*#__PURE__*/ _jsx("tfoot", {
                                            style: {
                                                background: "#CCC"
                                            },
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        colSpan: "6",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px]",
                                                            children: t("Net Total")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        style: {
                                                            textAlign: "right",
                                                            padding: "8px"
                                                        },
                                                        colSpan: "1",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "text-right mb-[0px]",
                                                            children: NumberFormat(totalNet, 2)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px]",
                                                            children: t("Baht")
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs("div", {
                        className: "pagezoom",
                        children: [
                            /*#__PURE__*/ _jsxs(Stack, {
                                direction: "row",
                                justifyContent: "space-between",
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-20",
                                        children: t("shopping cart")
                                    }),
                                    /*#__PURE__*/ _jsxs(Tooltip, {
                                        title: t("change language"),
                                        onClick: function(e) {
                                            return onClickLanguage();
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(LanguageIcon, {
                                                style: {
                                                    fontSize: 30,
                                                    cursor: "pointer"
                                                },
                                                className: "me-2"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: language == "th" ? "ภาษาไทย" : "ພາສາລາວ"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Stack, {
                                direction: "row",
                                justifyContent: "flex-end",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    className: "btn btn-dg w-[150px] my-2",
                                    to: "/catalog/".concat(typeIdShop, "?openExternalBrowser=1"),
                                    children: t("add products")
                                })
                            }),
                            rowData.map(function(row, i) {
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "card card-st-3 mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-2",
                                            children: [
                                                row.tmprs_catalog_image && /*#__PURE__*/ _jsx("img", {
                                                    src: row.tmprs_catalog_image,
                                                    alt: "สินค้า",
                                                    className: "w-full h-40 object-contain bg-white"
                                                }),
                                                /*#__PURE__*/ _jsx(Stack, {
                                                    direction: "row",
                                                    justifyContent: "flex-start",
                                                    style: {
                                                        borderBottom: "1px solid #CCC"
                                                    },
                                                    children: /*#__PURE__*/ _jsxs("span", {
                                                        className: "",
                                                        children: [
                                                            isCartProductNew(row) && /*#__PURE__*/ _jsx("div", {
                                                                className: "font-semibold text-danger fs-14",
                                                                children: "NEW"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-[10px] text-left",
                                                                children: getCartProductDisplayName(row, language)
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-[10px] tc-7 fs-12 text-left",
                                                                children: getCartProductSecondaryName(row)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "my-2",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                            type: "checkbox",
                                                            label: "ของแถม",
                                                            checked: Number(row.tmprs_catalog_free) === 2,
                                                            onChange: function(e) {
                                                                var _row_TmprsDetail;
                                                                var isFree = e.target.checked;
                                                                var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                if (!firstDetail) return;
                                                                updateCatalogLocal(row.tmprs_catalog_id, _object_spread({
                                                                    tmprs_catalog_free: isFree ? 2 : 1
                                                                }, isFree && {
                                                                    tmprs_catalog_tester: 1
                                                                }));
                                                                var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                    free: isFree ? 2 : 1,
                                                                    tester: isFree ? 1 : Number(row.tmprs_catalog_tester) === 2 ? 2 : 1
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                            type: "checkbox",
                                                            label: "สินค้าทดลอง",
                                                            checked: Number(row.tmprs_catalog_tester) === 2,
                                                            onChange: function(e) {
                                                                var _row_TmprsDetail;
                                                                var isTester = e.target.checked;
                                                                var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                if (!firstDetail) return;
                                                                updateCatalogLocal(row.tmprs_catalog_id, _object_spread({
                                                                    tmprs_catalog_tester: isTester ? 2 : 1
                                                                }, isTester && {
                                                                    tmprs_catalog_free: 1
                                                                }));
                                                                var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                    free: isTester ? 1 : Number(row.tmprs_catalog_free) === 2 ? 2 : 1,
                                                                    tester: isTester ? 2 : 1
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            as: "textarea",
                                                            rows: 2,
                                                            className: "mt-2 fs-14",
                                                            placeholder: "หมายเหตุ",
                                                            value: row.tmprs_catalog_remark || "",
                                                            onChange: function(e) {
                                                                return updateCatalogLocal(row.tmprs_catalog_id, {
                                                                    tmprs_catalog_remark: e.target.value
                                                                });
                                                            },
                                                            onBlur: function(e) {
                                                                var _row_TmprsDetail;
                                                                var firstDetail = (_row_TmprsDetail = row.TmprsDetail) === null || _row_TmprsDetail === void 0 ? void 0 : _row_TmprsDetail[0];
                                                                if (!firstDetail) return;
                                                                var _firstDetail_tmprs_detail_amount, _firstDetail_tmprs_detail_wholesale;
                                                                onChangeUpdateCart(firstDetail, (_firstDetail_tmprs_detail_amount = firstDetail.tmprs_detail_amount) !== null && _firstDetail_tmprs_detail_amount !== void 0 ? _firstDetail_tmprs_detail_amount : 0, (_firstDetail_tmprs_detail_wholesale = firstDetail.tmprs_detail_wholesale) !== null && _firstDetail_tmprs_detail_wholesale !== void 0 ? _firstDetail_tmprs_detail_wholesale : 0, {
                                                                    remark: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                row.TmprsDetail.map(function(ele, index) /*#__PURE__*/ {
                                                    var _ele_clDetail;
                                                    var _ele_tmprs_detail_wholesale, _ele_tmprs_detail_amount;
                                                    return _jsxs("div", {
                                                        style: {
                                                            borderBottom: "1px solid #CCC"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Stack, {
                                                                direction: "row",
                                                                // className="mt-3"
                                                                justifyContent: "space-between",
                                                                className: "mb-3 fs-14 mt-2",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-start",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-center py-2",
                                                                            children: (ele === null || ele === void 0 ? void 0 : (_ele_clDetail = ele.clDetail) === null || _ele_clDetail === void 0 ? void 0 : _ele_clDetail.cl_detail_showbarcode) == 1 ? ele.tmprs_detail_barcode : ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-end",
                                                                        children: /*#__PURE__*/ _jsxs("span", {
                                                                            className: "pl-3 mt-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        width: "40px"
                                                                                    },
                                                                                    children: language == "th" ? " ".concat(ele.setUnit.set_unit_name) : " ".concat(ele.setUnit.set_unit_namela)
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "="
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                                    style: {
                                                                                        borderRadius: 5
                                                                                    },
                                                                                    children: ele.tmprs_detail_ratio ? " ".concat(ele.tmprs_detail_ratio) : ""
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: ele.tmprs_detail_ratio ? " ".concat(t("item")) : ""
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: ele.tmprs_detail_ratiooption ? " / ".concat(ele.tmprs_detail_ratiooption, " ").concat(t("pack")) : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Stack, {
                                                                direction: "row",
                                                                justifyContent: "space-between",
                                                                className: "fs-14",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-start",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "grid grid-cols-1 text-gray-700 w-full",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex flex-col",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "flex justify-between items-center gap-2",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                                    children: "Ex VAT:"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "text",
                                                                                                    inputMode: "decimal",
                                                                                                    pattern: "[0-9]*[.]?[0-9]*",
                                                                                                    className: "text-end fs-14",
                                                                                                    style: {
                                                                                                        width: 110
                                                                                                    },
                                                                                                    value: isComplimentaryCartProduct(row) ? 0 : (_ele_tmprs_detail_wholesale = ele.tmprs_detail_wholesale) !== null && _ele_tmprs_detail_wholesale !== void 0 ? _ele_tmprs_detail_wholesale : "",
                                                                                                    disabled: isComplimentaryCartProduct(row),
                                                                                                    onChange: function(e) {
                                                                                                        var newValue = normalizeDecimalInput(e.target.value);
                                                                                                        updateDetailLocal(ele.idDetail, {
                                                                                                            tmprs_detail_wholesale: newValue
                                                                                                        });
                                                                                                    },
                                                                                                    onBlur: function(e) {
                                                                                                        var newValue = normalizeDecimalInput(e.target.value);
                                                                                                        var _ele_tmprs_detail_amount;
                                                                                                        onChangeUpdateCart(ele, (_ele_tmprs_detail_amount = ele.tmprs_detail_amount) !== null && _ele_tmprs_detail_amount !== void 0 ? _ele_tmprs_detail_amount : 0, newValue);
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            style: {
                                                                                                display: "none"
                                                                                            },
                                                                                            children: ele.tmprs_detail_wholesaledis ? /*#__PURE__*/ _jsxs("span", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                                                        className: "flex justify-between",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                                children: "Ex VAT:"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                                className: "text-red-600",
                                                                                                                children: NumberFormat(ele.tmprs_detail_wholesaledis ? ele.tmprs_detail_wholesaledis : 0, 2)
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                                        className: "flex justify-between",
                                                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                                                            className: "line-through text-gray-400",
                                                                                                            children: NumberFormat(ele.tmprs_detail_wholesale ? ele.tmprs_detail_wholesale : 0, 2)
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }) : /*#__PURE__*/ _jsxs("div", {
                                                                                                className: "flex justify-between",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        children: "Ex VAT:"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        children: NumberFormat(ele.tmprs_detail_wholesale, 2)
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "flex flex-col",
                                                                                    children: isComplimentaryCartProduct(row) ? /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "flex justify-between",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                children: "In VAT:"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                children: NumberFormat(0, 2)
                                                                                            })
                                                                                        ]
                                                                                    }) : ele.tmprs_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs("span", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                                className: "flex justify-between",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        children: "In VAT:"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-red-600",
                                                                                                        children: NumberFormat(ele.tmprs_detail_wholesalevatdis ? ele.tmprs_detail_wholesalevatdis : 0, 2)
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "flex justify-between",
                                                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "line-through text-gray-400",
                                                                                                    children: NumberFormat(ele.tmprs_detail_wholesalevat ? ele.tmprs_detail_wholesalevat : 0, 2)
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }) : /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "flex justify-between",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                children: "In VAT:"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                children: NumberFormat(ele.tmprs_detail_wholesalevat, 2)
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-end",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ _jsx("input", {
                                                                                type: "text",
                                                                                inputMode: "numeric",
                                                                                pattern: "[0-9]*",
                                                                                className: "form-control w-[50px] fs-14",
                                                                                value: (_ele_tmprs_detail_amount = ele.tmprs_detail_amount) !== null && _ele_tmprs_detail_amount !== void 0 ? _ele_tmprs_detail_amount : 0,
                                                                                onChange: function(e) {
                                                                                    var newValue = normalizeQuantityInput(e.target.value);
                                                                                    onChangeUpdateCart(ele, newValue === "" ? 0 : newValue);
                                                                                    updateDetailLocal(ele.idDetail, {
                                                                                        tmprs_detail_amount: newValue
                                                                                    });
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-left mb-3 fs-14 py-1",
                                                                children: [
                                                                    t("total"),
                                                                    " ",
                                                                    NumberFormat(isComplimentaryCartProduct(row) ? 0 : ele.tmprs_detail_net, 2),
                                                                    " ",
                                                                    t("Baht")
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("button", {
                                            onClick: function() {
                                                setModalDel(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true,
                                                        data: {
                                                            id: row.tmprs_catalog_id,
                                                            name: row.tmprs_catalog_name
                                                        }
                                                    });
                                                });
                                                setmodelText(t("confirm product deletion"));
                                            },
                                            className: "mt-1 w-full flex items-center justify-center px-3 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600",
                                            children: [
                                                /*#__PURE__*/ _jsx(DeleteIcon, {
                                                    className: "mr-2",
                                                    style: {
                                                        fontSize: 18
                                                    }
                                                }),
                                                t("delete product")
                                            ]
                                        })
                                    ]
                                }, i);
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body px-2",
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: t("Net Total")
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    NumberFormat(totalNet, 2),
                                                    " ",
                                                    t("Baht")
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "pagezoom",
                        children: /*#__PURE__*/ _jsx(Formik, {
                            enableReinitialize: true,
                            initialValues: formData,
                            validationSchema: schema,
                            onSubmit: function(values) {
                                var data = {
                                    guestid: parseInt(guestId),
                                    shopid: parseInt(values.branch_shid),
                                    branchid: parseInt(values.branchid),
                                    rs_reserve_shipping_paytype: Number(values.rs_reserve_shipping_paytype)
                                };
                                dispatch(submitCart(data, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                }));
                            },
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: function(e) {
                                        e.preventDefault();
                                        handleSubmit();
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("fieldset", {
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "card-body",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "pt-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-12 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-20",
                                                                        children: t("shop information")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                style: {
                                                                                    zIndex: 11
                                                                                },
                                                                                children: t("shop")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "shop_name",
                                                                                className: "form-control",
                                                                                placeholder: t("shop"),
                                                                                value: values.shop_name,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("branch")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "branch_name",
                                                                                className: "form-control",
                                                                                placeholder: t("branch"),
                                                                                value: values.branch_name,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("issue date")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "catalog_credate",
                                                                                className: "form-control",
                                                                                placeholder: t("issue date"),
                                                                                value: values.catalog_credate,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("caring sale")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sale",
                                                                                className: "form-control",
                                                                                placeholder: t("caring sale displayed automatically"),
                                                                                value: values.sale,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "shipping-payment-field",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "shipping-payment-title",
                                                                                children: t("shipping payment method")
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "shipping-payment-options",
                                                                                role: "radiogroup",
                                                                                "aria-label": t("shipping payment method"),
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        type: "radio",
                                                                                        name: "rs_reserve_shipping_paytype",
                                                                                        id: "shipping-pay-origin",
                                                                                        className: "shipping-payment-option".concat(Number(values.rs_reserve_shipping_paytype) === 1 ? " is-selected" : "").concat(!canSelectOriginShipping ? " is-disabled" : ""),
                                                                                        label: t("pay at origin"),
                                                                                        value: 1,
                                                                                        checked: Number(values.rs_reserve_shipping_paytype) === 1,
                                                                                        disabled: !canSelectOriginShipping,
                                                                                        onChange: function() {
                                                                                            return setFieldValue("rs_reserve_shipping_paytype", 1);
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        type: "radio",
                                                                                        name: "rs_reserve_shipping_paytype",
                                                                                        id: "shipping-pay-destination",
                                                                                        className: "shipping-payment-option".concat(Number(values.rs_reserve_shipping_paytype) === 2 ? " is-selected" : ""),
                                                                                        label: t("pay at destination"),
                                                                                        value: 2,
                                                                                        checked: Number(values.rs_reserve_shipping_paytype) === 2,
                                                                                        onChange: function() {
                                                                                            return setFieldValue("rs_reserve_shipping_paytype", 2);
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-12 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-20",
                                                                        children: t("contact information 1")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("fullname")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_contactname",
                                                                                className: "form-control",
                                                                                placeholder: t("fullname displayed automatically"),
                                                                                value: values.sh_branch_contactname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("phone")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_contactphone",
                                                                                className: "form-control",
                                                                                placeholder: t("phone displayed automatically"),
                                                                                value: values.sh_branch_contactphone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-12 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-20",
                                                                        children: t("contact information 2")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("fullname")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_suptactname",
                                                                                className: "form-control",
                                                                                placeholder: t("fullname displayed automatically"),
                                                                                value: values.sh_branch_suptactname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-lg-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: t("phone")
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_suptactphone",
                                                                                className: "form-control",
                                                                                placeholder: t("phone displayed automatically"),
                                                                                value: values.sh_branch_suptactphone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card pagezoom card-st-3  mb-4",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body px-xl-3 d-flex ",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        onClick: function(e) {
                                                            navigate("/catalog/".concat(typeIdShop, "?openExternalBrowser=1"));
                                                        },
                                                        className: "btn-st-6 me-3 btn ms-auto",
                                                        children: t("back")
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        disabled: rowData.length > 0 ? false : true,
                                                        onClick: function(e) {
                                                            handleSubmit();
                                                            e.preventDefault();
                                                        },
                                                        className: "btn-dg me-3",
                                                        children: t("save")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    guestId: guestId,
                    shopBranch: shopBranch,
                    cartPayload: cartPayload,
                    typeIdShop: typeIdShop
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: submitDialog,
                setModal: setSubmitDialog,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(SubmitDialog, {
                    lineWarning: dataPrint === null || dataPrint === void 0 ? void 0 : dataPrint.lineWarning,
                    setModal: setSubmitDialog,
                    modal: submitDialog,
                    handleOpenPrint: handleOpenPrint,
                    handleDownload: handleDownload,
                    typeIdShop: typeIdShop
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function SubmitDialog(param) {
    var lineWarning = param.lineWarning, modal = param.modal, setModal = param.setModal, handleOpenPrint = param.handleOpenPrint, handleDownload = param.handleDownload, typeIdShop = param.typeIdShop;
    var navigate = useNavigate();
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var onClickModel = function() {
        handleDownload();
    // handleOpenPrint();
    // setModal((prev) => ({ ...prev, open: false }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "pagezoom",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4 ",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5",
                    children: t("cart_text1")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5",
                    children: t("cart_text2")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5",
                    children: t("cart_text3")
                }),
                lineWarning && /*#__PURE__*/ _jsx("div", {
                    className: "alert alert-warning mt-3",
                    role: "alert",
                    children: lineWarning
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                navigate("/catalog/".concat(typeIdShop, "?openExternalBrowser=1"));
                            },
                            children: t("cancel")
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: t("print")
                        })
                    ]
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, guestId = param.guestId, shopBranch = param.shopBranch, cartPayload = param.cartPayload;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var deleteCartReducer = useAppSelector(function(state) {
        return state.deleteCartReducer;
    });
    useEffect(function() {
        setIsLoading(deleteCartReducer.isFetching);
        if (deleteCartReducer.data && !deleteCartReducer.isError) {
            setTextsuccess("ลบรายการสินค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteCart());
            if (cartPayload) {
                dispatch(myCart(cartPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            // dispatch(
            //   myCart(parseInt(guestId), {
            //     modalObj,
            //     setModalObj,
            //   })
            // );
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteCartReducer,
        cartPayload
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        console.log("delete");
        var data = {
            guestid: parseInt(guestId),
            catalogid: parseInt(id)
        };
        dispatch(deleteCart(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "pagezoom",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4 ",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5",
                    children: t("you want to delete this information")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: t("cancel")
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: t("confirm")
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
// ฟอนต์ภาษาไทย
Font.register({
    family: "Sarabun",
    fonts: [
        {
            src: sarabun
        },
        {
            src: sarabunBold,
            fontWeight: "bold"
        }
    ]
});
// ฟอนต์ภาษาลาว
Font.register({
    family: "NotoSansLao",
    fonts: [
        {
            src: NotoSansLao
        },
        {
            src: NotoSansLaoBold,
            fontWeight: "bold"
        }
    ]
});
Font.register({
    family: "Phetsarath",
    fonts: [
        {
            src: phetsarath
        },
        {
            src: phetsarathBold,
            fontWeight: "bold"
        }
    ]
});
var PagePrintPDF = function(param) {
    var dataFrom = param.dataFrom, dataItem = param.dataItem, typeIdShop = param.typeIdShop, language = param.language;
    var _dataFrom_rs_reserve_shopname, _dataFrom_sysSaleid;
    var _obj;
    var styles = StyleSheet.create((_obj = {
        page: {
            fontFamily: [
                "Sarabun",
                "Phetsarath"
            ],
            fontSize: 10,
            padding: 30,
            backgroundColor: "#fff",
            lineHeight: 1.4
        },
        logo: {
            width: 90
        },
        subTitle: {
            fontSize: 12,
            marginBottom: 2,
            color: "#333"
        },
        title: {
            fontSize: 14,
            fontWeight: "bold",
            color: "#B00412"
        },
        headerRow: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 12,
            alignItems: "center"
        },
        table: {
            display: "table",
            width: "auto",
            marginTop: 10,
            borderWidth: 1,
            borderColor: "#E2E8F0",
            borderStyle: "solid"
        },
        tableRow: {
            flexDirection: "row"
        },
        tableHeader: {
            flex: 1,
            borderRight: "1px solid #E2E8F0",
            backgroundColor: "#F6E1E3",
            padding: 6,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        tableCell: {
            flex: 1,
            borderRight: "1px solid #E2E8F0",
            borderTop: "1px solid #E2E8F0",
            padding: 5,
            fontSize: 10,
            textAlign: "center"
        },
        footer: {
            marginTop: 24,
            textAlign: "right",
            fontSize: 12
        },
        tableHeaderNo: {
            // สำหรับ "ลำดับ"
            flex: 0.3,
            borderRight: "1px solid #E2E8F0",
            backgroundColor: "#F6E1E3",
            padding: 6,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        tableHeaderImage: {
            // สำหรับ "รูปสินค้า"
            flex: 0.5,
            borderRight: "1px solid #E2E8F0",
            backgroundColor: "#F6E1E3",
            padding: 6,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        tableHeaderName: {
            // สำหรับ "ชื่อสินค้า"
            flex: 1.5,
            borderRight: "1px solid #E2E8F0",
            backgroundColor: "#F6E1E3",
            padding: 6,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        tableHeaderBarcode: {
            // สำหรับ "บาร์โค้ด"
            flex: 1.2,
            borderRight: "1px solid #E2E8F0",
            backgroundColor: "#F6E1E3",
            padding: 6,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        }
    }, _define_property(_obj, "tableHeader", {
        // สำหรับคอลัมน์อื่นๆ
        flex: 1,
        borderRight: "1px solid #E2E8F0",
        backgroundColor: "#F6E1E3",
        padding: 6,
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center"
    }), // Cell styles
    _define_property(_obj, "tableCellNo", {
        flex: 0.3,
        borderRight: "1px solid #E2E8F0",
        borderTop: "1px solid #E2E8F0",
        padding: 5,
        fontSize: 10,
        textAlign: "center"
    }), _define_property(_obj, "tableCellImage", {
        flex: 0.5,
        borderRight: "1px solid #E2E8F0",
        borderTop: "1px solid #E2E8F0",
        padding: 5,
        fontSize: 10,
        textAlign: "center"
    }), _define_property(_obj, "tableCellName", {
        flex: 1.5,
        borderRight: "1px solid #E2E8F0",
        borderTop: "1px solid #E2E8F0",
        padding: 5,
        fontSize: 10,
        textAlign: "left"
    }), _define_property(_obj, "tableCellBarcode", {
        flex: 1.2,
        borderRight: "1px solid #E2E8F0",
        borderTop: "1px solid #E2E8F0",
        padding: 5,
        fontSize: 10,
        textAlign: "center"
    }), _define_property(_obj, "productNamePrimary", {
        fontSize: 10
    }), _define_property(_obj, "productNameSecondary", {
        fontSize: 9,
        color: "#666666"
    }), _define_property(_obj, "productNameNew", {
        fontSize: 9,
        color: "#B00412",
        fontWeight: "bold"
    }), _obj));
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var _dataFrom_rs_reserve_shopname_trim;
    var companyName = (_dataFrom_rs_reserve_shopname_trim = dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_rs_reserve_shopname = dataFrom.rs_reserve_shopname) === null || _dataFrom_rs_reserve_shopname === void 0 ? void 0 : _dataFrom_rs_reserve_shopname.trim()) !== null && _dataFrom_rs_reserve_shopname_trim !== void 0 ? _dataFrom_rs_reserve_shopname_trim : "";
    var companyBranch = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_branchname;
    var _dataFrom_rs_reserve_code;
    var rsReserveCode = (_dataFrom_rs_reserve_code = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_code) !== null && _dataFrom_rs_reserve_code !== void 0 ? _dataFrom_rs_reserve_code : "-";
    var rsIssueDate = (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_credate) ? moment(dataFrom.rs_reserve_credate).format("DD/MM/YYYY") : "-";
    var rsStatus = (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_status) == 1 && t("Signature") || (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_status) == 2 && t("Confirmed") || (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_status) == 3 && t("cancel") || "-";
    var _dataFrom_rs_reserve_salename;
    var rsSaleName = (_dataFrom_rs_reserve_salename = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_salename) !== null && _dataFrom_rs_reserve_salename !== void 0 ? _dataFrom_rs_reserve_salename : "-";
    var _dataFrom_sysSaleid_sys_user_phone;
    var reSalePhone = (_dataFrom_sysSaleid_sys_user_phone = dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_sysSaleid = dataFrom.sysSaleid) === null || _dataFrom_sysSaleid === void 0 ? void 0 : _dataFrom_sysSaleid.sys_user_phone) !== null && _dataFrom_sysSaleid_sys_user_phone !== void 0 ? _dataFrom_sysSaleid_sys_user_phone : "-";
    var _dataFrom_rs_reserve_contactname;
    var contactName = (_dataFrom_rs_reserve_contactname = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_contactname) !== null && _dataFrom_rs_reserve_contactname !== void 0 ? _dataFrom_rs_reserve_contactname : "-";
    var _dataFrom_rs_reserve_contactphone;
    var contactPhone = (_dataFrom_rs_reserve_contactphone = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_contactphone) !== null && _dataFrom_rs_reserve_contactphone !== void 0 ? _dataFrom_rs_reserve_contactphone : "-";
    var _dataFrom_rs_reserve_suptactname;
    var subContactName = (_dataFrom_rs_reserve_suptactname = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_suptactname) !== null && _dataFrom_rs_reserve_suptactname !== void 0 ? _dataFrom_rs_reserve_suptactname : "-";
    var _dataFrom_rs_reserve_suptactphone;
    var subContactPhone = (_dataFrom_rs_reserve_suptactphone = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_suptactphone) !== null && _dataFrom_rs_reserve_suptactphone !== void 0 ? _dataFrom_rs_reserve_suptactphone : "-";
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.headerRow,
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/pardesco-logo-new-red-200.png",
                            style: styles.logo
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                alignItems: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: styles.subTitle,
                                    children: [
                                        "(",
                                        t("Original"),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.title,
                                    children: t("Product Reservation Form")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                borderBottom: "1px solid #909090",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("Customer"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: companyName ? "".concat(companyName, " (").concat(companyBranch, ")") : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("Contact Person"),
                                                " 1 :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: contactName !== null && contactName !== void 0 ? contactName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("phone"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: contactPhone !== null && contactPhone !== void 0 ? contactPhone : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                borderBottom: "1px solid #909090",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("caring sale"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: rsSaleName !== null && rsSaleName !== void 0 ? rsSaleName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("phone"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: reSalePhone !== null && reSalePhone !== void 0 ? reSalePhone : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("Contact Person"),
                                                " 2 :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: subContactName !== null && subContactName !== void 0 ? subContactName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: [
                                                t("phone"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: subContactPhone !== null && subContactPhone !== void 0 ? subContactPhone : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 6
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 90
                                            },
                                            children: [
                                                t("Document No"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: rsReserveCode !== null && rsReserveCode !== void 0 ? rsReserveCode : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 90
                                            },
                                            children: [
                                                t("Document Date"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: rsIssueDate !== null && rsIssueDate !== void 0 ? rsIssueDate : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 90
                                            },
                                            children: [
                                                t("Status"),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: rsStatus !== null && rsStatus !== void 0 ? rsStatus : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.table,
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.tableRow,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeaderNo,
                                    children: t("number")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeaderImage,
                                    children: t("product image")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeaderName,
                                    children: t("product name")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeaderBarcode,
                                    children: t("barcode")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: t("packaging size")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: t("number of products")
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: t("Unit")
                                })
                            ]
                        }),
                        dataItem && dataItem.length > 0 ? dataItem.map(function(item, index) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCellNo,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: index + 1
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCellImage,
                                        children: item.tmprs_catalog_image && /*#__PURE__*/ _jsx(Image, {
                                            src: item.tmprs_catalog_image,
                                            style: {
                                                width: 40,
                                                height: 40,
                                                margin: "auto"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: styles.tableCellName,
                                        children: [
                                            isCartProductNew(item) && /*#__PURE__*/ _jsx(Text, {
                                                style: styles.productNameNew,
                                                children: "NEW"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.productNamePrimary,
                                                children: getCartProductDisplayName(item, language)
                                            }),
                                            Number(item.tmprs_catalog_free) === 2 && /*#__PURE__*/ _jsx(Text, {
                                                style: styles.productNameNew,
                                                children: "ของแถม"
                                            }),
                                            Number(item.tmprs_catalog_tester) === 2 && /*#__PURE__*/ _jsx(Text, {
                                                style: styles.productNameNew,
                                                children: "สินค้าทดลอง"
                                            }),
                                            item.tmprs_catalog_remark ? /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.productNameSecondary,
                                                children: [
                                                    "หมายเหตุ: ",
                                                    item.tmprs_catalog_remark
                                                ]
                                            }) : null,
                                            getCartProductSecondaryName(item) ? /*#__PURE__*/ _jsx(Text, {
                                                style: styles.productNameSecondary,
                                                children: getCartProductSecondaryName(item)
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCellBarcode,
                                        children: item.TmprsDetail.map(function(b, i) {
                                            var _b_clDetail;
                                            return b.tmprs_detail_amount > 0 && /*#__PURE__*/ _jsx(Text, {
                                                children: (b === null || b === void 0 ? void 0 : (_b_clDetail = b.clDetail) === null || _b_clDetail === void 0 ? void 0 : _b_clDetail.cl_detail_showbarcode) == 1 ? b.tmprs_detail_barcode : ""
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: item.TmprsDetail.map(function(b, i) {
                                            var _b_setUnit, _b_setUnit1, _b_setUnit2, _b_setUnit3;
                                            return b.tmprs_detail_amount > 0 && /*#__PURE__*/ _jsx(Text, {
                                                children: language == "th" ? "".concat((_b_setUnit = b.setUnit) === null || _b_setUnit === void 0 ? void 0 : _b_setUnit.set_unit_name, " = ").concat(b.tmprs_detail_ratio, " ").concat((_b_setUnit1 = b.setUnit) === null || _b_setUnit1 === void 0 ? void 0 : _b_setUnit1.set_unit_name, " ").concat(b.tmprs_detail_ratiooption ? "/ ".concat(b.tmprs_detail_ratiooption, " ").concat(t("pack")) : "") : "".concat((_b_setUnit2 = b.setUnit) === null || _b_setUnit2 === void 0 ? void 0 : _b_setUnit2.set_unit_namela, " = ").concat(b.tmprs_detail_ratio, " ").concat((_b_setUnit3 = b.setUnit) === null || _b_setUnit3 === void 0 ? void 0 : _b_setUnit3.set_unit_namela, " ").concat(b.tmprs_detail_ratiooption ? "/ ".concat(b.tmprs_detail_ratiooption, " ").concat(t("pack")) : "")
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: item.TmprsDetail.map(function(b, i) {
                                            return b.tmprs_detail_amount > 0 && /*#__PURE__*/ _jsx(Text, {
                                                children: b.tmprs_detail_amount
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: item.TmprsDetail.map(function(b, i) {
                                            var _b_setUnit, _b_setUnit1;
                                            return b.tmprs_detail_amount > 0 && /*#__PURE__*/ _jsx(Text, {
                                                children: language == "th" ? (_b_setUnit = b.setUnit) === null || _b_setUnit === void 0 ? void 0 : _b_setUnit.set_unit_name : (_b_setUnit1 = b.setUnit) === null || _b_setUnit1 === void 0 ? void 0 : _b_setUnit1.set_unit_namela
                                            }, i);
                                        })
                                    })
                                ]
                            }, index);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: [
                                    styles.tableCell,
                                    {
                                        flex: 1
                                    }
                                ],
                                children: t('No Data Found"')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    style: styles.footer,
                    children: [
                        t("Date"),
                        " __________/__________/__________"
                    ]
                })
            ]
        })
    });
};
